import { formatedDate } from '@/utils/date.util'

/**
 * Returns the element array for any media
 * @param {string} items items to parse
 * @param {string} type type of media
 * @param {string} status action status (add, edit, delete)
 * @param {string} itemId item to edit or remove
 * @returns {string} Parsed and formatted time
 */
export const mediaParser = (items, type, status, selectedItem, mediaUrl = null) => {
  if (status === 'delete') {
    if (type === 'locationPictures') {
      return items.filter(item => item !== selectedItem.picture)
    }
    return items.filter(item => item.id !== selectedItem.id)
  } else if (status === 'edit') {
    const index = items.findIndex(item => item.id === selectedItem.id)
    const cloneItems = [...items]
    if (type === 'event' || type === 'dynamicContent') {
      cloneItems[index] = {
        id: selectedItem.id,
        alt: selectedItem.alt,
        title: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        link: selectedItem.link,
        linkTitle: selectedItem.linkTitle,
        description: selectedItem.description,
        picture: mediaUrl,
        from: selectedItem.from ? formatedDate(selectedItem.from, 'YYYY-MM-DD') : '',
        to: selectedItem.to ? formatedDate(selectedItem.to, 'YYYY-MM-DD') : '',
        publication_from: selectedItem.publication_from
          ? formatedDate(selectedItem.publication_from, 'YYYY-MM-DD')
          : '',
        publication_to: selectedItem.publication_to ? formatedDate(selectedItem.publication_to, 'YYYY-MM-DD') : '',
        tags: selectedItem.tags,
      }
    } else if (type === 'hotPictures') {
      cloneItems[index] = {
        id: selectedItem.id,
        name: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        alt: selectedItem.alt,
        url: selectedItem.link,
        picture_url: mediaUrl,
      }
    } else if (type === 'team') {
      cloneItems[index] = {
        id: selectedItem.id,
        alt: selectedItem.alt,
        title: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        link: selectedItem.link,
        picture: mediaUrl,
        linkTitle: selectedItem.linkTitle,
        description: selectedItem.description,
      }
    }
    return cloneItems
  } else if (status === 'add') {
    const cloneItems = items ? [...items] : []
    if (type === 'event' || type === 'dynamicContent') {
      cloneItems.push({
        id: `event-${cloneItems.length + 1}-${formatedDate('now', 'x')}`,
        alt: selectedItem.alt,
        title: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        link: selectedItem.link,
        linkTitle: selectedItem.linkTitle,
        description: selectedItem.description,
        picture: mediaUrl,
        from: selectedItem.from ? formatedDate(selectedItem.from, 'YYYY-MM-DD') : '',
        to: selectedItem.to ? formatedDate(selectedItem.to, 'YYYY-MM-DD') : '',
        publication_from: selectedItem.publication_from
          ? formatedDate(selectedItem.publication_from, 'YYYY-MM-DD')
          : '',
        publication_to: selectedItem.publication_to ? formatedDate(selectedItem.publication_to, 'YYYY-MM-DD') : '',
        tags: selectedItem.tags,
      })
    } else if (type === 'hotPictures') {
      cloneItems.push({
        id: `product-${cloneItems.length + 1}-${formatedDate('now', 'x')}`,
        name: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        alt: selectedItem.alt,
        url: selectedItem.link,
        picture_url: mediaUrl,
      })
    } else if (type === 'team') {
      cloneItems.push({
        id: `team-${cloneItems.length + 1}-${formatedDate('now', 'x')}`,
        alt: selectedItem.alt,
        title: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        link: selectedItem.link,
        linkTitle: selectedItem.linkTitle,
        description: selectedItem.description,
        picture: mediaUrl,
      })
    } else if (type === 'locationPictures') {
      cloneItems.push(mediaUrl)
    }
    return cloneItems
  } else if (status === 'clone') {
    if (type === 'event') {
      return {
        id: selectedItem.id,
        alt: selectedItem.alt,
        title: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        link: selectedItem.link,
        linkTitle: selectedItem.linkTitle,
        description: selectedItem.description,
        picture: mediaUrl,
        from: selectedItem.from ? formatedDate(selectedItem.from, 'YYYY-MM-DD') : '',
        to: selectedItem.to ? formatedDate(selectedItem.to, 'YYYY-MM-DD') : '',
        publication_from: selectedItem.publication_from
          ? formatedDate(selectedItem.publication_from, 'YYYY-MM-DD')
          : '',
        publication_to: selectedItem.publication_to ? formatedDate(selectedItem.publication_to, 'YYYY-MM-DD') : '',
        tags: selectedItem.tags,
      }
    } else if (type === 'hotPictures') {
      return {
        id: selectedItem.id,
        name: selectedItem.title,
        titleSeo: selectedItem.titleSeo,
        alt: selectedItem.alt,
        url: selectedItem.link,
        picture_url: mediaUrl,
      }
    } else if (type === 'locationPictures') {
      return mediaUrl
    }
  }
}
